import { render, staticRenderFns } from "./veStuChangeShow.vue?vue&type=template&id=459e914f&scoped=true"
import script from "./veStuChangeShow.vue?vue&type=script&lang=js"
export * from "./veStuChangeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e914f",
  null
  
)

export default component.exports